export enum TEmailFrequency {
  INSTANT = "INSTANT",
  NEVER = "NEVER",
}

export interface IEmailPreferences {
  applicationStatusUpdateEnabled: boolean;
  applicationSubmittedUpdateEnabled: boolean;
  applicationAcceptedUpdateEnabled: boolean;
  applicationRejectedUpdateEnabled: boolean;
  applicationWithdrawnUpdateEnabled: boolean;
  applicationPresentedUpdateEnabled: boolean;
  interviewScheduledUpdateEnabled: boolean;
  teamUpdateEnabled: boolean;
  assignmentStatusUpdateEnabled: boolean;
  dailyJobUpdateEnabled: boolean;
  applicationStatusFrequency: TEmailFrequency;
  timeReportApprovedEnabled: boolean;
  timeReportEnabled: boolean;
  timeReportRejectedEnabled: boolean;
  chatNewMessagesEnabled: boolean;
  jobRequestExpiredEnabled: boolean;
  jobPromotionsEnabled: boolean;
  privatePromotionsEnabled: boolean;
}
